import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';
import { AI_USAGE_DASHBOARD_TITLE } from './ai-usage.config';

@Component({
  selector: 'app-ai-usage-embed',
  templateUrl: './ai-usage-embed.component.html',
  styleUrls: ['./ai-usage-embed.component.scss'],
})
export class AiUsageEmbedComponent implements OnInit {
  pageTitle = AI_USAGE_DASHBOARD_TITLE;
  clientLogo: any;
  newColor: any;

  constructor(private readonly sessionService: SessionService) {}

  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();
  }
}
